export const REFERRAL_SHARE_MESSAGE =
  'I started using this tool to manage my orders and I’m not going back. If you sell on WhatsApp or IG you need to see this. Try it with my link:';

export const REFERRAL_SHARE_CTA = 'Share link';

export const REFERRAL_EMPTY_HEADLINE =
  'Other vendors are already earning from this.';

export const REFERRAL_EMPTY_BODY =
  'Every vendor you know who sells on WhatsApp or Instagram is a referral waiting to happen. Share your link. When they sell through Sellyt, you earn up to ₦1,500 every month for 6 months. Don’t let this sit.';

export const REFERRAL_WITHDRAW_MINIMUM = 5000;

export const REFERRAL_CREDIT_NOTE =
  'Referral earnings apply to subscription payments only. Platform fees on each sale are handled separately through Paystack.';

export const REFERRAL_WITHDRAW_NOTE =
  'Processed every Monday. Funds hit your account within 24 hours.';

export const REFERRAL_FOMO_MESSAGES = [
  'Tunde just earned ₦1,500 this month from one friend.',
  '12 vendors joined Sellyt today through referrals.',
  'Ada is one order away from your reward.',
  "You're in the top 8% of referrers this month.",
];
